export interface RegionalAerodrome {
  icao: string;
  name: string;
  lat: number;
  lon: number;
  elevation: number; // feet AMSL
}

// Quebec and Eastern Canada aerodromes database
export const QUEBEC_AERODROMES: RegionalAerodrome[] = [
  { icao: 'CYRC', name: 'Saint-Honoré', lat: 48.52, lon: -71.05, elevation: 545 },
  { icao: 'CYRJ', name: 'Roberval', lat: 48.52, lon: -72.265, elevation: 586 },
  { icao: 'CYSV', name: 'Sept-Îles', lat: 50.223, lon: -66.266, elevation: 180 },
  { icao: 'CSK5', name: 'Saint-Raymond', lat: 46.89, lon: -71.78, elevation: 560 },
  { icao: 'CYQB', name: 'Québec Jean Lesage', lat: 46.791, lon: -71.393, elevation: 244 },
  { icao: 'CYUL', name: 'Montréal Trudeau', lat: 45.47, lon: -73.741, elevation: 118 },
  { icao: 'CYHU', name: 'Montréal Saint-Hubert', lat: 45.518, lon: -73.416, elevation: 90 },
  { icao: 'CYJN', name: 'Saint-Jean-sur-Richelieu', lat: 45.294, lon: -73.281, elevation: 136 },
  { icao: 'CYSC', name: 'Sherbrooke', lat: 45.438, lon: -71.691, elevation: 792 },
  { icao: 'CYMT', name: 'Chibougamau-Chapais', lat: 49.771, lon: -74.528, elevation: 1270 },
  { icao: 'CYGR', name: 'Îles-de-la-Madeleine', lat: 47.425, lon: -61.778, elevation: 35 },
  { icao: 'CYQY', name: 'Sydney J.A. Douglas McCurdy', lat: 46.161, lon: -60.048, elevation: 203 },
  { icao: 'CYHZ', name: 'Halifax Stanfield', lat: 44.881, lon: -63.509, elevation: 477 },
  { icao: 'CYOW', name: 'Ottawa Macdonald-Cartier', lat: 45.322, lon: -75.669, elevation: 374 },
  { icao: 'CYTR', name: 'Trenton', lat: 44.119, lon: -77.528, elevation: 283 },
  { icao: 'CYAM', name: 'Sault Ste. Marie', lat: 46.485, lon: -84.509, elevation: 630 },
  { icao: 'CYWG', name: 'Winnipeg James Armstrong Richardson', lat: 49.91, lon: -97.239, elevation: 783 },
  { icao: 'CYQM', name: 'Moncton', lat: 46.112, lon: -64.679, elevation: 232 },
  { icao: 'CZBF', name: 'Bathurst', lat: 47.629, lon: -65.739, elevation: 193 },
  { icao: 'CYVO', name: 'Val-d\'Or', lat: 48.053, lon: -77.783, elevation: 1107 },
  { icao: 'CYRQ', name: 'Trois-Rivières', lat: 46.353, lon: -72.679, elevation: 199 },
  { icao: 'CYUY', name: 'Rouyn-Noranda', lat: 48.206, lon: -78.836, elevation: 988 },
  { icao: 'CYLA', name: 'Langlade', lat: 46.843, lon: -56.381, elevation: 13 },
  { icao: 'CYDP', name: 'Nain', lat: 56.549, lon: -61.683, elevation: 22 },
];

// French aerodromes (for when user selects a French terrain)
export const FRANCE_AERODROMES: RegionalAerodrome[] = [
  { icao: 'LFOI', name: 'Abbeville', lat: 50.143, lon: 1.832, elevation: 220 },
  { icao: 'LFOP', name: 'Rouen Vallée de Seine', lat: 49.384, lon: 1.175, elevation: 495 },
  { icao: 'LFPB', name: 'Paris Le Bourget', lat: 48.969, lon: 2.441, elevation: 217 },
  { icao: 'LFMN', name: 'Nice Côte d\'Azur', lat: 43.658, lon: 7.215, elevation: 13 },
  { icao: 'LFLL', name: 'Lyon Saint-Exupéry', lat: 45.726, lon: 5.090, elevation: 787 },
  { icao: 'LFLB', name: 'Chambéry Savoie', lat: 45.638, lon: 5.880, elevation: 768 },
  { icao: 'LFGJ', name: 'Dole-Tavaux', lat: 47.043, lon: 5.435, elevation: 620 },
  { icao: 'LFCR', name: 'Rodez Marcillac', lat: 44.407, lon: 2.482, elevation: 2123 },
  { icao: 'EDDS', name: 'Stuttgart', lat: 48.690, lon: 9.222, elevation: 1217 },
  { icao: 'LSZH', name: 'Zurich', lat: 47.458, lon: 8.548, elevation: 1416 },
  { icao: 'LFPG', name: 'Paris Charles de Gaulle', lat: 49.009, lon: 2.547, elevation: 392 },
  { icao: 'LFBD', name: 'Bordeaux Mérignac', lat: 44.828, lon: -0.715, elevation: 162 },
  { icao: 'LFML', name: 'Marseille Provence', lat: 43.436, lon: 5.215, elevation: 74 },
  { icao: 'LFBO', name: 'Toulouse Blagnac', lat: 43.629, lon: 1.363, elevation: 499 },
  { icao: 'LFRS', name: 'Nantes Atlantique', lat: 47.153, lon: -1.610, elevation: 90 },
];

/**
 * Returns the best set of regional aerodromes based on the selected aerodrome's country/location.
 * If the selected aerodrome is in Canada (lon < -50), return Quebec aerodromes.
 * Otherwise return French aerodromes.
 */
export function getRegionalAerodromes(lat: number, lon: number): RegionalAerodrome[] {
  if (lon < -30) {
    return QUEBEC_AERODROMES;
  }
  return FRANCE_AERODROMES;
}
